export { Ripple } from 'react-ripple-click'
import 'react-ripple-click/dist/index.css'
